// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2rzOL","footer":"ReportModalFilter_footer__2eGTr"};